<template>
  <v-autocomplete
    :data-testid="toKebabCase(field.label)"
    :class="{ required: field.required }"
    :model-value="field.value"
    :rules="validationRules"
    :items="field.dropDownValues"
    v-bind="{ ...$props, ...$attrs }"
    @update:model-value="value => $emit('input', value || '')"
    density="compact"
    clearable
    open-on-clear
    hide-details="auto"
    :placeholder="field.label"
    :persistent-placeholder="persistentPlaceholder ? Boolean(field.placeholder) : false"
    multiple>
    <template #label>
      {{ t('customFields.forms.customFieldsForm.placeholders.chooseOneOrMoreOptions') }}
    </template>
  </v-autocomplete>
</template>

<script>
import customFieldTypeMixin from '@/modules/custom_fields/mixins/customFieldTypeMixin';
import { t, toKebabCase } from '@nova/core';

export default {
  methods: { t, toKebabCase },
  name: 'custom-field-dropdownmultiselect',
  mixins: [customFieldTypeMixin]
};
</script>
